import React, { useState, useEffect } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { Form, FloatingLabel } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { LoadingModal } from "../../components/Index.js";
import { TalukServices } from "../../../services/Taluk";
import { PHCServices } from "../../../services/Phcs";
import { AuthService } from "../../../services/AuthService.js";
import AlertModal from "../../../components/AlertModal"; // ✅ use styled AlertModal

function EditPHCModal({ show, onHide, phc, onClose }) {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  // Taluk State
  const [taluks, setTaluks] = useState([]);

  useEffect(() => {
    const getTaluks = async () => {
      try {
        const res = await TalukServices.getAllTaluks();
        if (Array.isArray(res) && res.length > 0) {
          setTaluks(res);
        } else {
          setTaluks([]);
        }
      } catch (error) {
        setTaluks([]);
      }
    };
    getTaluks();
  }, []);

  // PHC State
  const [phcs, setPhcs] = useState({
    id: undefined,
    phc: "",
    talukId: undefined,
  });

  const [error, setError] = useState({
    phc: "",
    talukId: "",
  });

  const [alertData, setAlertData] = useState({
    show: false,
    title: "",
    message: "",
    variant: "info",
  });

  useEffect(() => {
    if (show && phc) {
      setPhcs({
        id: phc.id,
        phc: phc.phc,
        talukId: phc.talukId || "",
      });
    }
  }, [show, phc]);

  const validation = () => {
    let tempError = { phc: "", talukId: "" };
    let valid = true;
    if (!phcs.phc) {
      tempError.phc = "PHC is required";
      valid = false;
    }
    if (!phcs.talukId) {
      tempError.talukId = "Taluk is required";
      valid = false;
    }
    setError(tempError);
    return valid;
  };

  const update = async () => {
    if (validation()) {
      setLoading(true);
      try {
        const res = await PHCServices.updatePhc(phcs);
        if (res.status === 200) {
          setAlertData({
            show: true,
            title: "Success",
            message: res.message || "PHC updated successfully!",
            variant: "success",
          });
          onHide();
          onClose && onClose(); 
          navigate("/phc");
        } else {
          setAlertData({
            show: true,
            title: "Error",
            message: res.message || "Error while updating PHC",
            variant: "danger",
          });
        }
      } catch (error) {
        setAlertData({
          show: true,
          title: "Error",
          message: error.message || "Failed to update PHC",
          variant: "danger",
        });
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <>
      <Modal show={show} onHide={onHide} size="md" centered>
        <Modal.Header closeButton>
          <Modal.Title>Edit PHC</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <FloatingLabel controlId="editTaluk" label="Taluk*" className="mb-3">
            <Form.Select
              value={phcs.talukId}
              onChange={(e) => setPhcs({ ...phcs, talukId: e.target.value })}
              isInvalid={!!error.talukId}
            >
              <option value="">Select</option>
              {Array.isArray(taluks) &&
                taluks.map((i) => (
                  <option key={i.id} value={i.id}>
                    {i.taluk}
                  </option>
                ))}
            </Form.Select>
            <p className="required-field-meassage">{error.talukId}</p>
          </FloatingLabel>

          <FloatingLabel controlId="editPHC" label="PHC*">
            <Form.Control
              type="text"
              value={phcs.phc}
              onChange={(e) => setPhcs({ ...phcs, phc: e.target.value })}
              isInvalid={!!error.phc}
            />
            <p className="required-field-meassage">{error.phc}</p>
          </FloatingLabel>
        </Modal.Body>
        <Modal.Footer>
          {AuthService.canUpdate() && (
            <Button onClick={update} variant="success">
              Update
            </Button>
          )}
          <Button onClick={onHide} variant="danger">
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>

      <LoadingModal show={loading} />

      <AlertModal
        show={alertData.show}
        title={alertData.title}
        message={alertData.message}
        variant={alertData.variant}
        onHide={() => setAlertData({ ...alertData, show: false })}
      />
    </>
  );
}

function EditPHC(props) {
  const [modalShow, setModalShow] = useState(false);

  return (
    <>
      <FontAwesomeIcon
        icon={faEdit}
        size="lg"
        className="action-icon edit-icon"
        onClick={() => setModalShow(true)}
        title="Edit PHC"
      />
      <EditPHCModal
        show={modalShow}
        onHide={() => setModalShow(false)}
        onClose={props.onClose}
        phc={props.phc}
      />
    </>
  );
}

export default EditPHC;
